import styled, { createGlobalStyle, css } from 'styled-components';

import { ContentContainer } from 'brand-guidelines/Layout-styled-components';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

// Override app/global-styles.js so we can use our own styles here
export const CheckoutGlobalStyle = createGlobalStyle`
  /* Higher specificity than the default app selector */
  div#app {
    background: none;
    > * {
      flex: unset;
    }
  }
`;

export const CheckoutPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      gap: 16px;
    `,
  )}
`;

export const TopSection = styled.div`
  width: 100%;
`;

export const CheckoutStepWrapper = styled(ContentContainer)`
  display: flex;
  flex-direction: column;
  gap: 24px;

  /* Prevent tooltips from overflowing the right edge */
  overflow-x: clip;

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      padding: 0 16px;
    `,
  )}
`;
